//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

export default asyncComponent({
  resolve: () => import('./Accordion'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncAccordion',
})



// WEBPACK FOOTER //
// ./src/components/QuestionElements/Accordion/index.js